import FormattedMessage from 'I18n/components/FormattedMessage';
import ActionExecutionEnrollAnalysisReason from 'flow-doctor-lib/components/diagnosis/reasons/ActionExecutionEnrollAnalysisReason';
import BulkEnrollExistingAnalysisReason from 'flow-doctor-lib/components/diagnosis/reasons/BulkEnrollExistingAnalysisReason';
import BulkEnrollListAnalysisReason from 'flow-doctor-lib/components/diagnosis/reasons/BulkEnrollListAnalysisReason';
import BulkEnrollScheduledAnalysisReason from 'flow-doctor-lib/components/diagnosis/reasons/BulkEnrollScheduledAnalysisReason';
import ClassicReenrollmentAnalysisReason from 'flow-doctor-lib/components/diagnosis/reasons/ClassicReenrollmentAnalysisReason';
import DynamicEnrollAnalysisReason from 'flow-doctor-lib/components/diagnosis/reasons/DynamicEnrollAnalysisReason';
import EventEnrollmentAnalysisReason from 'flow-doctor-lib/components/diagnosis/reasons/EventEnrollAnalysisReason';
import EventEnrollListTriggerAnalysisReason from 'flow-doctor-lib/components/diagnosis/reasons/EventEnrollListTriggerAnalysisReason';
import EventReenrollmentAnalysisReason from 'flow-doctor-lib/components/diagnosis/reasons/EventReenrollmentAnalysisReason';
import ExternalTriggerEnrollAnalysisReason from 'flow-doctor-lib/components/diagnosis/reasons/ExnternalTriggerEnrollAnalysisReason';
import ManualEnrollmentAnalysisReason from 'flow-doctor-lib/components/diagnosis/reasons/ManualEnrollmentAnalysisReason';
import PersistedReenrollmentAnalysisReason from 'flow-doctor-lib/components/diagnosis/reasons/PersistedReenrollmentAnalysisReason';
import BulkEnrollFiltersAnalysisReason from 'flow-doctor-lib/components/diagnosis/reasons/BulkEnrollFiltersAnalysisReason';
import { jsx as _jsx } from "react/jsx-runtime";
const EnrollmentAnalysisReasons = ({
  diagnosisResult,
  selectedEnrollment
}) => {
  switch (diagnosisResult.reasonMetadata.reason) {
    case 'MANUAL_ENROLL':
      return /*#__PURE__*/_jsx(ManualEnrollmentAnalysisReason, {
        diagnosisReason: diagnosisResult.reasonMetadata,
        selectedEnrollment: selectedEnrollment
      });
    case 'BULK_ENROLL_EXISTING':
      return /*#__PURE__*/_jsx(BulkEnrollExistingAnalysisReason, {
        diagnosisReason: diagnosisResult.reasonMetadata,
        selectedEnrollment: selectedEnrollment
      });
    case 'BULK_ENROLL_LIST':
      return /*#__PURE__*/_jsx(BulkEnrollListAnalysisReason, {
        diagnosisReason: diagnosisResult.reasonMetadata,
        selectedEnrollment: selectedEnrollment
      });
    case 'BULK_ENROLL_SCHEDULED':
      return /*#__PURE__*/_jsx(BulkEnrollScheduledAnalysisReason, {});
    case 'BULK_ENROLL_FILTER':
      return /*#__PURE__*/_jsx(BulkEnrollFiltersAnalysisReason, {
        diagnosisReason: diagnosisResult.reasonMetadata,
        selectedEnrollment: selectedEnrollment
      });
    case 'EXTERNAL_TRIGGER_ENROLL':
      return /*#__PURE__*/_jsx(ExternalTriggerEnrollAnalysisReason, {
        diagnosisReason: diagnosisResult.reasonMetadata,
        selectedEnrollment: selectedEnrollment
      });
    case 'EVENT_ENROLL':
      return /*#__PURE__*/_jsx(EventEnrollmentAnalysisReason, {});
    case 'EVENT_RE_ENROLL':
      return /*#__PURE__*/_jsx(EventReenrollmentAnalysisReason, {
        diagnosisReason: diagnosisResult.reasonMetadata,
        selectedEnrollment: selectedEnrollment
      });
    case 'EVENT_ENROLL_LIST_TRIGGER':
      return /*#__PURE__*/_jsx(EventEnrollListTriggerAnalysisReason, {
        diagnosisReason: diagnosisResult.reasonMetadata,
        selectedEnrollment: selectedEnrollment
      });
    case 'ACTION_EXECUTION_ENROLL':
      return /*#__PURE__*/_jsx(ActionExecutionEnrollAnalysisReason, {
        selectedEnrollment: selectedEnrollment
      });
    case 'CLASSIC_RE_ENROLL':
      return /*#__PURE__*/_jsx(ClassicReenrollmentAnalysisReason, {});
    case 'PERSISTED_RE_ENROLL':
      return /*#__PURE__*/_jsx(PersistedReenrollmentAnalysisReason, {});
    case 'DYNAMIC_ENROLL':
      return /*#__PURE__*/_jsx(DynamicEnrollAnalysisReason, {});
    case 'UNKNOWN':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: `flow-doctor-lib.flows.diagnosticWizard.enrollmentAnalysis.enrollTypeReason.types.${selectedEnrollment.enrollType}`
      });
    default:
      return null;
  }
};
export default EnrollmentAnalysisReasons;